/* =========================================================
   LASTU × CONCEPT – teemakerros (3.8.2026)

   Siirretty live-teemasta (Dynamo), Conceptin DOM:iin sovitettuna:
     1. Customily-piilotuotteiden ketjupoisto korista
     2. Cart-thumbnailin pakotus (Customilyn snapshot voittaa)
     3. Korin thumbnail-lightbox
     4. Tuotekuvauksen clamp + "Lue lisää" / "Näytä vähemmän"

   Conceptille kirjoitettu lisäys (4.8.2026):
     5. Lisätieto-drawer: sivu/artikkeli Conceptin drawerissa
     6. SEO-intron "Lue koko tuotekuvaus" -linkki

   Conceptin cart-API (vrt. Dynamo):
     refresh + avaus : document.dispatchEvent('cart:refresh', {detail:{open:true}})
     rivin poisto    : <a is="cart-remove-button" data-index="LINE_KEY">
     rivin juuri     : li#CartDrawer-Item-KEY (drawer) / tr#CartItem-KEY (korisivu)
   ========================================================= */

/* =========================================================
   0. VIDEOIDEN LAISKA LATAUS (5.8.2026)

   MIKSI: 5.8. autoplay-videot siirrettiin <template>:istä suoraan
   DOM:iin, jotta ne toistuvat mobiilissa. Sivupaino räjähti, koska
   selain lataa autoplay-videon kokonaan heti – mitattuna kokoelmasivu
   47,7 Mt (44 Mt videoita, yksi 28,7 Mt) ja tuotesivu 44,0 Mt.
   preload="none" ei auta: autoplay kumoaa sen.

   MITÄ: Liquid kirjoittaa <source src> muotoon data-lastu-src (ks.
   snippets/video.liquid). Tässä se palautetaan takaisin src:ksi vasta
   kun video lähestyy näkyvää aluetta. Selain ei siis voi ladata mitään
   ennen sitä, mutta <video> pysyy suoraan DOM:issa – 5.8. korjaus ei
   siis peruunnu.

   MIKSI OMANA LOHKONAAN JA ENSIMMÄISENÄ: alla oleva teemakerros alkaa
   __lastuConceptLayerLoaded-vartiolla ja sisältää korilogiikkaa. Jos
   siellä joskus poikkeaa jokin, videot eivät saa jäädä lataamatta.
   Tämä lohko on siksi täysin erillinen eikä jaa mitään tilaa sen kanssa.

   YHTEENSOPIVUUS TEEMAN KANSSA: teeman VideoMedia toistaa videon vasta
   Motion.inView-koukusta (assets/theme.js, DeferredMedia). Sen
   canplay-kuuntelija on {once:true} eikä laukea lähteettömälle videolle,
   joten se odottaa promotointia ja käynnistää toiston normaalisti.
   Tämä lohko siis siirtää vain LATAUKSEN samaan hetkeen kuin TOISTON.
   ========================================================= */
(function () {
  'use strict';

  if (window.__lastuVideoDeferLoaded) return;
  window.__lastuVideoDeferLoaded = true;

  var SRC_ATTR = 'data-lastu-src';

  /* Aloitetaan lataus 400 px ennen näkyvää aluetta, jotta video ehtii
     puskuroida ennen kuin teeman oma inView-koukku käskee toistaa.

     Sivusuunnassa 200 px: tuotegallerian diat ovat vaakaliukurissa
     (overflow:hidden), jolloin IntersectionObserver laskee liukurin
     leikkaaman alueen. Marginaali käynnistää latauksen noin puoli
     pyyhkäisyä ennen kuin dia asettuu kohdalleen. Isompaa arvoa ei
     kannata antaa: jokainen naapuridia on oma videotiedostonsa. */
  var ROOT_MARGIN = '400px 200px';

  /* Data Saver: teema jättää autoplayn tekemättä (DeferredMedia
     connectedCallback), joten videota ei ole syytä ladatakaan.
     Posterikuva jää näkyviin, mikä on juuri haluttu lopputulos. */
  var connection = navigator.connection;
  var saveData = !!(connection && connection.saveData);

  /* --- Videot eivät saa kilpailla LCP-kuvan kanssa ------------------
     Ensimmäinen versio promotoi taitteen yläpuolisen hero-videon heti
     DOMContentLoadedissa. Mitattuna se maksoi kokoelmasivulla LCP-kuvan
     latausajassa 415 ms → 1591 ms: 28 megan video söi kaistan juuri kun
     suurin kuva oli latautumassa.

     Siksi ennen window.loadia osuvat promotoinnit jonotetaan ja
     puretaan vasta sen jälkeen. Taitteen alapuolisiin videoihin tällä
     ei ole vaikutusta – ne osuvat näkyviin joka tapauksessa vasta
     myöhemmin. Katsoja näkee sillä välin posterikuvan, eli täsmälleen
     saman kuin teeman oma ristihäivytys näyttää muutenkin. */
  var pageLoaded = document.readyState === 'complete';
  var queued = [];

  function flushQueue() {
    if (pageLoaded) return;
    pageLoaded = true;
    var q = queued;
    queued = [];
    for (var i = 0; i < q.length; i++) startLoading(q[i]);
  }

  if (!pageLoaded) {
    window.addEventListener('load', function () {
      /* Pieni lisäviive: window.load laukeaa ennen kuin selain on
         ehtinyt rauhoittua, ja rIC odottaa oikean tyhjän hetken.
         Timeout varmistaa ettei jää roikkumaan jos sivu on kiireinen. */
      if ('requestIdleCallback' in window) requestIdleCallback(flushQueue, { timeout: 1500 });
      else setTimeout(flushQueue, 400);
    }, { once: true });

    /* Varmistin: jos load ei jostain syystä laukea (esim. ikuisesti
       latautuva kolmannen osapuolen resurssi), videot eivät saa jäädä
       pysyvästi lataamatta. */
    setTimeout(flushQueue, 8000);
  }

  function startLoading(video) {
    try { video.load(); } catch (e) {}

    /* Varmistus autoplaylle: load() nollaa toiston, eikä iOS aina
       käynnistä uudelleenladattua elementtiä pelkän attribuutin
       perusteella. Mykistys pakotetaan, koska mobiiliselaimet torjuvat
       äänellisen automaattitoiston (sama perustelu kuin theme.js:n
       attemptPlay-korjauksessa). Teeman oma ketju tekee saman kohta
       perässä – kaksi play()-kutsua on vaaraton. */
    if (video.hasAttribute('autoplay')) {
      try {
        video.defaultMuted = true;
        video.muted = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      } catch (e) {}
    }
  }

  function promote(container) {
    /* Upotettu iframe (YouTube tuotekuvauksessa): pelkkä src riittää.
       Mitattuna 5.8. tuotesivulla yksi YouTube-upotus veti 1,05 Mt heti
       sivun auetessa, vaikka se on syvällä kuvauksessa. loading="lazy"
       ei riitä iframelle, kun sivu on pitkä ja Chrome arvioi sen
       "todennäköisesti näkyväksi". */
    if (container.tagName === 'IFRAME') {
      var iframeUrl = container.getAttribute(SRC_ATTR);
      if (iframeUrl) container.setAttribute('src', iframeUrl);
      container.removeAttribute(SRC_ATTR);
      return;
    }

    var sources = container.querySelectorAll('source[' + SRC_ATTR + ']');
    if (!sources.length) return;

    for (var i = 0; i < sources.length; i++) {
      var s = sources[i];
      var url = s.getAttribute(SRC_ATTR);
      if (url) s.setAttribute('src', url);
      s.removeAttribute(SRC_ATTR);
    }

    var video = container.querySelector('video');
    if (!video) return;

    /* load() saa selaimen huomaamaan uudet lähteet. Ilman sitä juuri
       asetettu src jää huomiotta, koska media-elementti on jo käynyt
       läpi lähteenvalinnan tyhjänä. Ennen window.loadia jonoon. */
    if (pageLoaded) startLoading(video);
    else queued.push(video);
  }

  var observer = null;

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        observer.unobserve(entries[i].target);
        promote(entries[i].target);
      }
    }, { rootMargin: ROOT_MARGIN });
  }

  function watch(el) {
    if (!el || el.__lastuWatched) return;
    el.__lastuWatched = true;
    if (observer) observer.observe(el);
    else promote(el);                     // ei IntersectionObserveria → vanha käytös
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;

    /* Videot: tarkkaillaan <video-media>-kääreitä, koska teeman CSS ja
       toistologiikka elävät siinä – ei yksittäisiä <source>-elementtejä. */
    var sources = scope.querySelectorAll('source[' + SRC_ATTR + ']');
    for (var i = 0; i < sources.length; i++) {
      watch(sources[i].closest('video-media') || sources[i].parentNode);
    }

    var frames = scope.querySelectorAll('iframe[' + SRC_ATTR + ']');
    for (var j = 0; j < frames.length; j++) {
      watch(frames[j]);
    }
  }

  function scanSafe(root) {
    try { scan(root); } catch (e) {}
  }

  function start() {
    if (saveData) return;
    scanSafe(document);

    /* Teemaeditorin sektiolataus ja dynaamisesti lisätty sisältö
       (pikakatselu, korin drawer) tuovat uusia videoita jälkikäteen. */
    document.addEventListener('shopify:section:load', function (e) {
      scanSafe(e.target || document);
    });

    if ('MutationObserver' in window) {
      var timer = null;
      new MutationObserver(function () {
        if (timer) return;
        timer = setTimeout(function () {
          timer = null;
          scanSafe(document);
        }, 250);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(function () {
  'use strict';

  if (window.__lastuConceptLayerLoaded) return;
  window.__lastuConceptLayerLoaded = true;

  function refreshCart(open) {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { open: open === true, source: 'lastu-concept' }
      }));
    } catch (e) {}

    // Headerin <cart-count> ym. kuuntelevat teeman pubsubia, eivät
    // cart:refreshiä → julkaistaan tuore korin tila erikseen.
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        try {
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'lastu-concept',
              cart: cart
            });
          }
        } catch (e) {}
      })
      .catch(function () {});
  }

  /* ════════════════════════════════════════════════════════════
     1. Customilyn piilorivien TUNNISTUS

     Customily lisää kaiverrukset, MagSafen yms. koriin omina rivinään,
     joita ei näytetä. Tätä tunnistusta käytetään korin tuotelaskurissa,
     jotta piilorivit eivät kasvata näkyvää kappalemäärää.

     Poiston hoitaa Customily itse – ks. perustelut alempaa.
     ════════════════════════════════════════════════════════════ */
  function isCustomilyOptionItem(item) {
    if (item.properties) {
      if (item.properties['_customily-upsell-id'] !== undefined &&
          item.properties['_customily-upsell-id'] !== '') return true;
    }
    if (item.product_type === 'OPTIONS_HIDDEN_PRODUCT') return true;
    if (item.title && (item.title.indexOf('Lisäsit ') !== -1 || item.title.indexOf('Valittu ') !== -1)) return true;
    return false;
  }

  /* ────────────────────────────────────────────────────────────────
     KETJUPOISTO POISTETTU 6.8.2026 – Customily hoitaa sen jo itse.

     Täällä oli oma klikkikäsittelijä joka poisti piilorivit kun päätuote
     poistettiin. Se oli sekä tarpeeton että haitallinen:

     1. Customily tekee ketjupoiston itse ja tuotekohtaisesti. Konsoliin
        tulee "Customily Shopify: handling cart" ja verkkoon omat kutsut
        /cart/update.js?customily_upsell ja /cart/change.js?customily_upsell.
     2. Tämä käsittelijä poisti cart.itemsin KAIKKI piilorivit riippumatta
        omistajasta → kahden kustomoidun tuotteen korissa toisen poisto vei
        myös toisen maksetut lisäosat.
     3. Vaikka ryhmittely korjattiin _customily-upsell-main-id:llä, kaksi
        rinnakkaista korikirjoittajaa jäi kilpailemaan: Customily ehti
        poistaa piilorivit ensin, jolloin tämän oma /cart/update.js lähti
        vanhentuneilla avaimilla ja Shopify vastasi 422 – eikä silloin
        sovella päivityksestä MITÄÄN, joten päätuote jäi koriin.

     Mitattu 6.8.2026 ilman tätä lohkoa (Customily yksin):
       · kaksi kustomoitua tuotetta, toinen poistetaan → toisen lisäosat
         säilyvät, total täsmää                                    ✅
       · viimeisen tuotteen poisto → kori täysin tyhjä, ei jäänteitä ✅
       · tavallinen tuote korissa kustomoidun rinnalla → koskematon ✅

     isCustomilyOptionItem jää käyttöön alempana (korin tuotelaskuri).

     HUOM: käsin väärennetty "orpo" piilorivi (upsell-id jota kukaan ei
     omista) ei siivoudu. Yksikään oikea Customily-polku ei tuottanut
     sellaista testeissä, eikä siivousta lisätty – se tarkoittaisi taas
     yhtä rinnakkaista korikirjoittajaa, mikä oli koko tämän bugin syy.
     ──────────────────────────────────────────────────────────────── */

  /* Tyhjennä kori -nappi (jos sellainen lisätään sectioniin) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lastu-clear-cart]');
    if (!btn) return;
    e.preventDefault();
    var en = (document.documentElement.lang || '').indexOf('en') === 0;
    if (!window.confirm(en ? 'Clear the cart? Your designed cases will be removed.' : 'Tyhjennetäänkö ostoskori? Suunnittelemasi kuoret poistuvat.')) return;
    btn.disabled = true;
    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function () { refreshCart(false); })
      .catch(function () {})
      .finally(function () { btn.disabled = false; });
  });

  /* ════════════════════════════════════════════════════════════
     1b. Korikuvakkeen lukema = vain näkyvät rivit

     Liquid-puolella tämän hoitaa snippets/lastu-cart-count.liquid.
     Kun teema päivittää korin JS:llä, <cart-count> saa taas raa'an
     cart.item_countin (= sisältää piilorivit) → korjataan se tässä.
     Tilaus tehdään scriptin latauduttua, eli teeman oman
     CartCount-kuuntelijan JÄLKEEN → meidän arvomme jää voimaan.
     ════════════════════════════════════════════════════════════ */
  function visibleItemCount(cart) {
    if (!cart || !cart.items) return null;
    return cart.items.reduce(function (sum, item) {
      return isCustomilyOptionItem(item) ? sum : sum + item.quantity;
    }, 0);
  }

  function applyVisibleCount(cart) {
    var n = visibleItemCount(cart);
    if (n === null) return;
    document.querySelectorAll('cart-count').forEach(function (el) {
      el.innerText = String(n);
      el.hidden = n === 0;
    });
  }

  (function initCartCountFix() {
    function subscribe() {
      try {
        if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
          theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
            if (event && event.cart && !event.cart.errors) applyVisibleCount(event.cart);
          });
          return true;
        }
      } catch (e) {}
      return false;
    }
    if (!subscribe()) {
      // theme.js latautuu defer-järjestyksessä – yritetään uudelleen
      [100, 400, 1000].forEach(function (ms) { setTimeout(subscribe, ms); });
    }
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) applyVisibleCount(e.detail.cart);
    });
  })();

  /* ════════════════════════════════════════════════════════════
     2. CART-THUMBNAILIN PAKOTUS

     Lähde: window.__lastuPreviewByKey { cartLineKey: dataURL }
            (täyttää Customily Custom JS -moduuli 17)

     Ydinongelma: Customilyn oma cart-thumbnail ylikirjoittaa
     olemassa olevan <img>-elementin SRC-ATTRIBUUTIN (ei korvaa
     solmua). Siksi pelkkä childList-observer ei riitä – kuunnellaan
     myös attribuuttimuutoksia ja palautetaan snapshot heti takaisin.
     ════════════════════════════════════════════════════════════ */
  (function initThumbForce() {
    function safeSel(v) {
      if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(v);
      return String(v).replace(/"/g, '\\"');
    }

    function imgForKey(key) {
      var k = safeSel(key);
      var row =
        document.getElementById('CartDrawer-Item-' + key) ||
        document.getElementById('CartItem-' + key) ||
        document.querySelector('[data-index="' + k + '"]')?.closest('li, tr');
      if (row) {
        var im = row.querySelector('.lastu-cart-thumb img, .horizontal-product__media img, .cart-item__media img');
        if (im) return im;
      }
      return null;
    }

    // Erottaa omat kirjoituksemme Customilyn kirjoituksista, ettei
    // attribuuttiobserver jää ikuiseen silmukkaan.
    var writing = false;

    function paintKey(key, src) {
      if (!key || !src) return;
      var img = imgForKey(key);
      if (!img) return;
      if (img.getAttribute('src') === src &&
          img.getAttribute('data-lastu-preview') === '1' &&
          !img.getAttribute('srcset')) {
        return; // jo oikein
      }
      writing = true;
      img.setAttribute('src', src);
      img.removeAttribute('srcset');
      img.setAttribute('data-lastu-preview', '1');
      // Conceptin lazy-image jää muuten "loading"-tilaan
      img.classList.remove('is-loading');
      if (img.hasAttribute('loading')) img.setAttribute('loading', 'eager');
      writing = false;
    }

    function paintAll() {
      var map = window.__lastuPreviewByKey;
      if (!map) return;
      Object.keys(map).forEach(function (k) { paintKey(k, map[k]); });
    }

    /* localStorage-persistointi: __lastuPreviewByKey elää vain muistissa,
       joten snapshotit katosivat sivulatauksessa. Cart-line-keyt säilyvät
       saman korin yli → avaimet täsmäävät myös reloadin jälkeen. */
    var LS_KEY = 'lastuCartPreviews';
    function restoreFromLS() {
      try {
        var raw = localStorage.getItem(LS_KEY);
        if (!raw) return;
        var stored = JSON.parse(raw);
        if (!stored || typeof stored !== 'object') return;
        window.__lastuPreviewByKey = window.__lastuPreviewByKey || {};
        Object.keys(stored).forEach(function (k) {
          if (!window.__lastuPreviewByKey[k]) window.__lastuPreviewByKey[k] = stored[k];
        });
      } catch (e) {}
    }
    function saveToLS() {
      try {
        localStorage.setItem(LS_KEY, JSON.stringify(window.__lastuPreviewByKey || {}));
      } catch (e) { /* quota / private mode → ohitetaan */ }
    }
    restoreFromLS();

    var raf = false;
    function schedulePaint() {
      if (raf) return;
      if (!window.__lastuPreviewByKey || !Object.keys(window.__lastuPreviewByKey).length) return;
      raf = true;
      requestAnimationFrame(function () { raf = false; paintAll(); });
    }

    var obs = new MutationObserver(function (mutations) {
      if (writing) return;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'attributes' && m.target && m.target.getAttribute &&
            m.target.getAttribute('data-lastu-preview') === '1') {
          schedulePaint();
          return;
        }
        if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
          schedulePaint();
          return;
        }
      }
    });
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset']
    });

    function burst() {
      paintAll();
      [80, 200, 500, 1000, 1800].forEach(function (ms) { setTimeout(paintAll, ms); });
    }
    document.addEventListener('lastu:preview:stored', burst);
    document.addEventListener('lastu:preview:stored', saveToLS);
    document.addEventListener('cart:updated', burst);
    document.addEventListener('cart:updated', saveToLS);
    document.addEventListener('lastu:cart:rendered', burst);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', burst, { once: true });
    } else {
      burst();
    }
  })();

  /* ════════════════════════════════════════════════════════════
     3. Korin thumbnail-lightbox
     ════════════════════════════════════════════════════════════ */
  (function initCartLightbox() {
    function getFullSrc(src) {
      if (!src) return src;
      return src
        .replace(/_\d+x\d*\.(jpg|jpeg|png|webp)/i, '.$1')
        .replace(/[?&]width=\d+/g, '')
        .replace(/[?&]height=\d+/g, '')
        .replace(/\?$/, '');
    }

    function closeLightbox(overlay) {
      if (!overlay || !overlay.parentNode) return;
      overlay.style.animation = 'lastu-lb-in .15s ease reverse both';
      setTimeout(function () {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 160);
    }

    function openLightbox(src) {
      var old = document.querySelector('.lastu-lightbox');
      if (old) old.parentNode.removeChild(old);

      var overlay = document.createElement('div');
      overlay.className = 'lastu-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');

      var img = document.createElement('img');
      img.className = 'lastu-lightbox__img';
      img.src = getFullSrc(src);
      img.alt = '';

      var closeBtn = document.createElement('button');
      closeBtn.className = 'lastu-lightbox__close';
      closeBtn.innerHTML = '&times;';
      closeBtn.setAttribute('aria-label', (document.documentElement.lang || '').indexOf('en') === 0 ? 'Close image' : 'Sulje kuva');
      closeBtn.type = 'button';

      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeLightbox(overlay);
      });

      overlay.addEventListener('click', function (e) {
        e.stopPropagation();
        if (e.target === overlay) closeLightbox(overlay);
      });

      document.addEventListener('keydown', function onEsc(e) {
        if (e.key === 'Escape') {
          e.stopPropagation();
          e.stopImmediatePropagation();
          closeLightbox(overlay);
          document.removeEventListener('keydown', onEsc);
        }
      }, true);

      overlay.appendChild(img);
      overlay.appendChild(closeBtn);

      // Liitetään drawerin sisään, ettei Conceptin "klikkaus ulkopuolelle"
      // -käsittelijä tulkitse lightboxia drawerin ulkopuoliseksi klikkaukseksi.
      var drawer = document.querySelector('cart-drawer[open]') || document.body;
      drawer.appendChild(overlay);
      closeBtn.focus();
    }

    function patchThumbnails() {
      document.querySelectorAll('.lastu-cart-thumb').forEach(function (thumb) {
        if (thumb.dataset.lastuLbBound === '1') return;
        thumb.dataset.lastuLbBound = '1';

        thumb.addEventListener('click', function (e) {
          var img = thumb.querySelector('img');
          if (!img || !img.src) return;
          e.preventDefault();
          e.stopPropagation();
          openLightbox(img.src);
        });
      });
    }

    patchThumbnails();
    document.addEventListener('cart:updated', function () {
      setTimeout(patchThumbnails, 100);
      setTimeout(patchThumbnails, 400);
    });
    document.addEventListener('lastu:cart:rendered', function () {
      setTimeout(patchThumbnails, 100);
    });
    // Debounce: Customilyn canvas tuottaa jatkuvasti DOM-mutaatioita,
    // joten sidonta ajetaan korkeintaan kerran per frame.
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; patchThumbnails(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();

  /* ════════════════════════════════════════════════════════════
     5. Customilyn lisähinnat → ATC-painikkeeseen (4.8.2026)

     TAUSTA: Customily päivittää tuotesivun hinnan itse, kun valitaan
     maksullinen lisävalinta (MagSafe +5 €, kaiverrus +5 € …). Se etsii
     hinnan snippets/product-price.liquidiin lisätystä
     [data-product-price]-elementistä. Conceptin ATC-painikkeessa on
     kuitenkin OMA hintansa (<product-buy-price>), joka näyttää yhä
     pelkän perushinnan – asiakas näkee napissa 19,90 € vaikka
     todellinen hinta on 24,90 €.

     MIKSI OMA TOTEUTUS EIKÄ LIVE-TEEMAN: tarkistin live-teeman
     (Palo Alto) käytöksen 4.8.2026. Siellä päähinta päivittyy oikein,
     mutta Customily Custom JS:n peilimoduuli jää jälkeen – se sitoo
     MutationObserverin suoraan hintaelementtiin, ja kun Customily
     korvaa solmun, observer jää irralleen kuolleeseen nodeen. Live
     näytti napissa 19,90 € vaikka hinta oli jo 24,90 €.
     Tässä observer sidotaan PYSYVÄÄN esivanhempaan (.product__price),
     joten solmun vaihtuminen ei katkaise seurantaa.
     ════════════════════════════════════════════════════════════ */
  (function initCustomilyPriceSync() {
    if (!/\/products\//.test(window.location.pathname)) return;

    function priceSource() {
      /* Kantoasiakas (2.9.2026): jos snippets/lastu-loyalty.liquid on
         luonut peilin, jossa on tason mukainen vähennys, nappi näyttää
         sen. Peili on erillinen elementti ilman data-product-pricea,
         jotta Customily ei kirjoita siihen. */
      var loyalty = document.querySelector('.lastu-loyalty-price');
      if (loyalty && loyalty.textContent.trim()) return loyalty;
      // Ei napin sisältä eikä Customilyn omasta paneelista
      return [].slice
        .call(document.querySelectorAll('[data-product-price]'))
        .filter(function (el) {
          return !el.closest('button') && !el.closest('#cl_optionsapp');
        })[0] || null;
    }

    function targets() {
      return [].slice.call(document.querySelectorAll('product-buy-price'));
    }

    /* Ei välimuistia edellisestä arvosta: verrataan aina kohteen omaan
       tekstiin. Näin synkka korjaa itsensä myös silloin kun Concept
       renderöi napin uusiksi variantin vaihtuessa ja nollaa hinnan
       perushintaan. Kirjoitus tapahtuu vain kun teksti oikeasti eroaa,
       joten silmukkaa MutationObserverin kanssa ei synny. */
    function sync() {
      var src = priceSource();
      if (!src) return;
      var txt = (src.textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) return;
      targets().forEach(function (el) {
        if (el.textContent.replace(/\s+/g, ' ').trim() !== txt) el.textContent = txt;
      });
    }

    /* Vahti setTimeoutilla EIKÄ requestAnimationFramella.

       rAF ei laukea lainkaan kun välilehti ei renderöi (taustavälilehti,
       minimoitu ikkuna). Silloin lippu jäisi pysyvästi päälle ja synkka
       lakkaisi toimimasta koko loppuistunnon ajaksi – myös sen jälkeen
       kun käyttäjä palaa välilehdelle. setTimeout hidastuu taustalla
       mutta ei jää koskaan jumiin. Todettu tässä ympäristössä:
       rAF-versio ei päivittynyt kertaakaan. */
    var timer = 0;
    function schedule() {
      if (timer) return;
      timer = setTimeout(function () { timer = 0; sync(); }, 50);
    }

    function bind() {
      /* Juureksi documentElement eikä .product__price.

         Ensimmäinen yritys sitoi observerin .product__price-elementtiin,
         eikä se toiminut: kun Customily valitsee puhelinmallin, Shopifyn
         variantti vaihtuu ja Concept renderöi koko hintalohkon uusiksi.
         Observer jäi roikkumaan irronneeseen solmuun – täsmälleen sama
         vika joka live-teeman peilimoduulissa on.

         documentElement ei koskaan vaihdu. rAF-vahti pitää kustannuksen
         kurissa: raskaimmillaankin yksi sync per frame. Sama kaava on jo
         käytössä tämän tiedoston thumbnail-moduulissa. */
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true
      });
      sync();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind, { once: true });
    } else {
      bind();
    }
    // Customily alustuu myöhään – varmistetaan muutama tarkistus
    [800, 2000, 4000].forEach(function (ms) { setTimeout(schedule, ms); });
  })();

  /* ════════════════════════════════════════════════════════════
     4. Tuotekuvauksen clamp – "Lue lisää / Näytä vähemmän"
     Concept renderöi kuvauksen kokonaisuudessaan; tämä vastaa
     live-teeman käytöstä.
     ════════════════════════════════════════════════════════════ */
  (function initDescriptionClamp() {
    var isEn = /^\/(en)(\/|$|\?)/.test(window.location.pathname);
    var CLAMP_LINES = 15;

    function run() {
      document.querySelectorAll('.product__text.rte:not([data-lastu-clamp])').forEach(function (descEl) {
        descEl.setAttribute('data-lastu-clamp', '1');

        var lh = parseFloat(window.getComputedStyle(descEl).lineHeight) || 24;
        var maxH = lh * CLAMP_LINES;

        if (descEl.scrollHeight <= maxH + 8) return;

        var wrap = document.createElement('div');
        wrap.className = 'lastu-desc-wrap lastu-desc-clamped';
        wrap.style.setProperty('--ldmax', maxH + 'px');
        descEl.parentNode.insertBefore(wrap, descEl);
        wrap.appendChild(descEl);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lastu-desc-btn';
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = isEn ? 'Read more' : 'Lue lisää';
        wrap.insertAdjacentElement('afterend', btn);

        btn.addEventListener('click', function () {
          var expanded = wrap.classList.toggle('lastu-desc-expanded');
          wrap.classList.toggle('lastu-desc-clamped', !expanded);
          btn.setAttribute('aria-expanded', String(expanded));
          btn.textContent = expanded
            ? (isEn ? 'Show less' : 'Näytä vähemmän')
            : (isEn ? 'Read more' : 'Lue lisää');
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    [400, 1200].forEach(function (ms) { setTimeout(run, ms); });
  })();

  /* ════════════════════════════════════════════════════════════
     5. Lisätieto-drawer – sivu tai artikkeli Conceptin drawerissa

     Mikä tahansa [data-lastu-info] avaa kohdesivun sisällön
     drawerissa poistumatta nykyiseltä sivulta. Markup ja ohjeet:
     snippets/lastu-info-drawer.liquid.
     ════════════════════════════════════════════════════════════ */
  (function initInfoDrawer() {
    var VIEW = 'lastu-info';
    var SCOPE = '#LastuInfoDrawer .lastu-info-drawer__body';
    var cache = {};

    var slugMap = null;

    function drawerEl() {
      return document.getElementById('LastuInfoDrawer');
    }

    /* Customilyn help texteissä olevat linkit ovat muotoa
       <a href="#" data-open-drawer="kaiverrus-esimerkkeja">. Tunniste ei
       ole sivun handle, joten teema kuljettaa käännöstaulukon drawerin
       attribuutissa – ks. snippets/lastu-info-drawer.liquid. Näin
       Customilyn koodeja ei tarvitse muuttaa. */
    function slugToUrl(slug) {
      if (slugMap === null) {
        var drawer = drawerEl();
        try {
          slugMap = JSON.parse((drawer && drawer.getAttribute('data-lastu-info-map')) || '{}');
        } catch (e) {
          slugMap = {};
        }
      }

      return slugMap[slug] || null;
    }

    /* ── Ladatun sisällön tyylien rajaus ──────────────────────
       Blogiartikkelit kuljettavat omat <style>-lohkonsa, ja niissä
       on tyypillisesti myös body-sääntö (max-width, padding, fontti).
       Sellaisenaan liitettynä se muotoilisi koko tuotesivun. Siksi
       jokainen sääntö kirjoitetaan uusiksi drawerin sisään: valitsimet
       saavat eteensä drawerin valitsimen.

       Pelkät html/body/:root-säännöt pudotetaan kokonaan. Ne on
       kirjoitettu HTML-vientiä varten (leveys, marginaalit, oma
       fonttipino) eivätkä kuulu drawerin sisään: fontti ei ole sivulla
       ladattuna ja putoaisi Georgiaan, ja padding tulisi Conceptin
       oman drawer-paddingin päälle. Typografia tulee teemalta.

       Jos jäsennys ei onnistu, tyylit jätetään kokonaan pois –
       sisältö on tärkeämpi kuin sen ilme, eikä sivua saa rikkoa. */
    function scopeSelector(selectorText, scope) {
      var parts = [];

      selectorText.split(',').forEach(function (part) {
        var sel = part.trim().replace(/^(?:html|body|:root)\b/i, '').trim();
        if (!sel) return;

        parts.push(scope + ' ' + sel);
      });

      return parts.join(', ');
    }

    function scopeRules(rules, scope, out) {
      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];

        if (rule.type === 1) {
          // Tavallinen sääntö
          var selector = scopeSelector(rule.selectorText, scope);
          if (selector) out.push(selector + '{' + rule.style.cssText + '}');
        } else if (rule.cssRules && (rule.type === 4 || rule.type === 12)) {
          // @media / @supports – sisältö rajataan rekursiivisesti
          var inner = [];
          scopeRules(rule.cssRules, scope, inner);
          var at = rule.type === 4
            ? '@media ' + rule.media.mediaText
            : '@supports ' + rule.conditionText;
          out.push(at + '{' + inner.join('') + '}');
        } else {
          // @keyframes, @font-face ym. – globaaleja, mutta vaarattomia
          out.push(rule.cssText);
        }
      }
    }

    function scopeStyles(root, scope) {
      var css = [];

      root.querySelectorAll('style').forEach(function (styleEl) {
        // media="not all" → selain jäsentää säännöt mutta ei sovella
        // niitä hetkeksikään sivuun.
        var probe = document.createElement('style');
        probe.media = 'not all';
        probe.textContent = styleEl.textContent;
        document.head.appendChild(probe);

        try {
          scopeRules(probe.sheet.cssRules, scope, css);
        } catch (e) {}

        probe.remove();
        styleEl.remove();
      });

      return css.join('\n');
    }

    function parseInfo(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var root = doc.getElementById('LastuInfoContent');

      if (!root) return null;

      root.querySelectorAll('script, meta, link, base, title').forEach(function (el) {
        el.remove();
      });

      var css = scopeStyles(root, SCOPE);

      /* Osa artikkeleista alkaa HTML-viennin jäänteillä: <p>-elementti
         jonka sisällä oli vain <meta>-tageja. Metat on juuri poistettu,
         joten jäljelle jäisi tyhjä kappale ja iso rako drawerin alkuun. */
      while (root.firstElementChild) {
        var lead = root.firstElementChild;
        var isEmpty = lead.textContent.trim() === '' &&
          !lead.querySelector('img, video, iframe, svg, picture');

        if (!isEmpty) break;
        lead.remove();
      }

      return {
        title: root.getAttribute('data-title') || '',
        html: root.innerHTML,
        css: css
      };
    }

    function fetchInfo(url) {
      if (cache[url]) return Promise.resolve(cache[url]);

      var target = new URL(url, window.location.href);
      target.searchParams.set('view', VIEW);

      return fetch(target.toString(), { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (text) {
          var data = parseInfo(text);
          if (!data) throw new Error('LastuInfoContent puuttuu');
          cache[url] = data;
          return data;
        });
    }

    function openInfo(url, title, trigger) {
      var drawer = drawerEl();
      if (!drawer) return false;

      var titleEl = drawer.querySelector('[data-lastu-info-title]');
      var bodyEl = drawer.querySelector('[data-lastu-info-body]');
      var styleEl = drawer.querySelector('[data-lastu-info-style]');
      var scrollEl = drawer.querySelector('.drawer__scrollable');

      if (!titleEl || !bodyEl || !styleEl) return false;

      drawer.dataset.currentUrl = url;
      titleEl.textContent = title || '';
      styleEl.textContent = '';
      bodyEl.textContent = drawer.getAttribute('data-loading-text') || '';

      if (typeof drawer.show === 'function') {
        drawer.show(trigger || null);
      } else {
        // Jos Conceptin custom element ei ole vielä alustunut,
        // avataan drawer suoraan attribuutilla.
        drawer.hidden = false;
        drawer.setAttribute('open', '');
      }

      fetchInfo(url).then(function (data) {
        // Käyttäjä ehti avata toisen sisällön → vanha vastaus hylätään.
        if (drawer.dataset.currentUrl !== url) return;

        if (data.title) titleEl.textContent = data.title;
        styleEl.textContent = data.css;
        bodyEl.innerHTML = data.html;
        if (scrollEl) scrollEl.scrollTop = 0;
      }).catch(function () {
        if (drawer.dataset.currentUrl !== url) return;

        var message = document.createElement('p');
        var link = document.createElement('a');

        link.href = url;
        link.textContent = drawer.getAttribute('data-error-link-text') || url;

        message.textContent = (drawer.getAttribute('data-error-text') || '') + ' ';
        message.appendChild(link);

        bodyEl.innerHTML = '';
        bodyEl.appendChild(message);
      });

      return true;
    }

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!event.target || !event.target.closest) return;

      var trigger = event.target.closest('[data-lastu-info], [data-open-drawer]');
      if (!trigger) return;

      var slug = trigger.getAttribute('data-open-drawer');
      var url = trigger.getAttribute('data-lastu-info');

      if (!url && slug) url = slugToUrl(slug);

      if (!url) {
        var href = trigger.getAttribute('href');
        // Customilyn linkeissä on href="#", joka ei ole osoite vaan
        // paikanpitäjä. Jos tunnistetta ei ole taulukossa, linkki jää
        // hiljaa toimettomaksi – sivu ei ainakaan hyppää ylös.
        if (href && href.charAt(0) !== '#') url = href;
      }

      if (!url) {
        if (slug) event.preventDefault();
        return;
      }

      var target;
      try {
        target = new URL(url, window.location.href);
      } catch (e) {
        return;
      }

      // Ulkoiset osoitteet saavat navigoida normaalisti.
      if (target.origin !== window.location.origin) return;

      if (openInfo(target.pathname + target.search, trigger.getAttribute('data-lastu-info-title'), trigger)) {
        event.preventDefault();
      }
    });
  })();

  /* ════════════════════════════════════════════════════════════
     6. SEO-intron "Lue koko tuotekuvaus"

     Vierittää tuotekuvaukseen ja avaa clampin. Jos kuvaus on niin
     lyhyt ettei clamppia (osa 4) ole luotu, riittää vieritys.
     ════════════════════════════════════════════════════════════ */
  (function initDescriptionLink() {
    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;

      var link = event.target.closest('[data-lastu-desc-link]');
      if (!link) return;

      var button = document.querySelector('.lastu-desc-btn');
      var target = button || document.querySelector('.product__text.rte');
      if (!target) return;

      target.scrollIntoView({ behavior: 'smooth', block: 'center' });

      if (!button) return;

      setTimeout(function () {
        if (button.getAttribute('aria-expanded') !== 'true') button.click();
      }, 650);
    });
  })();
})();

/* =========================================================
   CUSTOMILYN LATAUSVARMISTIN (6.8.2026)

   MIKSI: personointi on ostopolun pakollinen osa – ilman sitä
   tuotesivulla ei ole valintoja eikä ostonappia. Ketju on kuitenkin
   sarjallinen ja kulkee kahden ulkopuolisen origon kautta:
     teema → Customilyn upotus → code.jquery.com → customily.js
   Mitattu 6.8.2026: jQuery 1,3–2,7 s ja customily.js 2,5–4,3 s
   NOPEALLA kiinteällä yhteydellä. Jos jompikumpi pettää tai on hidas,
   asiakas näkee tuotesivun ilman personointia eikä voi ostaa.
   Todennettu: code.jquery.com estettynä personointia ei tule koskaan
   ("Customily Shopify Error: Failed to load script from URL").

   MITÄ: kolmiportainen palautus. Jokainen porras tekee vähiten mitä
   tilanne vaatii, ja koko ketju ajetaan vain jos sivulla PITÄISI olla
   personointi mutta sitä ei ole.

     1. 8 s   puuttuuko jQuery? → ladataan se varasijainnista
                (sama versio 2.2.4, jotta Customily käyttäytyy samoin)
     2. 14 s  onko Customilyn skripti jäänyt kokonaan lataamatta?
                → injektoidaan se uudelleen
     3. 20 s  ei vieläkään mitään → KERTALUONTOINEN sivun lataus

   Kolmas porras on tarkoituksella viimeinen keino ja lukittu
   sessionStorageen: se voi tapahtua kutakin tuotetta kohti VAIN kerran
   istunnossa, joten uudelleenlataussilmukka on mahdoton. Käyttäjän
   raportoima oire oli juuri tämä – "toimii kun lataa uudestaan".

   TURVA: ei tee mitään jos personointi on jo pystyssä, jos sivu ei ole
   tuotesivu, jos välilehti on taustalla (mittarit eivät juokse), tai jos
   asiakas on jo ehtinyt käyttää valitsinta.
   ========================================================= */
(function () {
  'use strict';

  if (window.__lastuCustomilyGuardLoaded) return;
  window.__lastuCustomilyGuardLoaded = true;

  /* Teeman oma kopio ensisijaisena: sama Shopify-CDN kuin theme.css,
     eikä ulkopuolisen palvelun katko voi estää sitä. Osoite luetaan
     head:iin kirjoitetusta tagista, jottei polkua tarvitse kovakoodata
     (Shopify liittää assetteihin versiotiivisteen). */
  var JQ_THEME_URL = (function () {
    var tag = document.querySelector('script[src*="jquery-2.2.4.min.js"][src*="/cdn/shop/"]');
    return tag ? tag.src : '';
  })();
  var JQ_VERSION_URL = 'https://code.jquery.com/jquery-2.2.4.min.js';
  var JQ_FALLBACK_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/2.2.4/jquery.min.js';

  /* Personointi katsotaan pystyssä olevaksi vasta kun siellä on oikeasti
     valittavaa. Pelkkä säiliön olemassaolo ei riitä: Customily luo
     #cl_optionsapp:n tyhjänä jo ennen kuin data on haettu. */
  function customizerReady() {
    var app = document.getElementById('cl_optionsapp');
    if (app && app.querySelector('input, select, .customily-swatch')) return true;
    return false;
  }

  /* KORJATTU 6.8.2026: ehtona on Customilyn SKRIPTITAGI, ei sen luomat
     elementit.

     Ensimmäinen versio katsoi #customily-options / #cl_optionsapp /
     #customily-main-app -elementtejä. Ne ovat Customilyn itsensä JS:llä
     luomia, joten juuri siinä tilanteessa jota vastaan varmistin on
     rakennettu (Customily ei käynnisty) niitä ei ole olemassa – ja
     varmistin lopetti heti. Todennettu jQuery estettynä: guard latautui
     mutta poistui välittömästi, koska kaikki kolme id:tä puuttuivat.

     Skriptitagi sen sijaan tulee palvelimelta sovellusupotuksessa, eli
     se on DOM:issa aina kun sivulla kuuluu olla personointi. */
  function expectsCustomizer() {
    return !!document.querySelector('script[src*="customily"]');
  }

  function loadScript(src, done) {
    var s = document.createElement('script');
    s.src = src;
    s.async = false;               // säilytä suoritusjärjestys
    s.crossOrigin = 'anonymous';
    s.onload = function () { done(true); };
    s.onerror = function () { done(false); };
    document.head.appendChild(s);
  }

  if (!expectsCustomizer()) return;

  var t0 = Date.now();
  var elapsedVisible = 0;
  var last = Date.now();
  var stage1Done = false, stage2Done = false;
  var userInteracted = false;

  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest && e.target.closest('#cl_optionsapp, #customily-options')) userInteracted = true;
  }, true);

  var timer = setInterval(function () {
    var now = Date.now();
    /* Lasketaan vain aika jolloin välilehti on ollut näkyvissä. Taustalla
       selain throttlaa ajastimet ja verkon, eikä hitaus ole silloin vika. */
    if (document.visibilityState === 'visible') elapsedVisible += now - last;
    last = now;

    if (customizerReady() || userInteracted) { clearInterval(timer); return; }

    /* 1. jQuery puuttuu → teeman oma kopio ensin, ulkoiset vasta sitten.

          Normaalisti tänne ei koskaan päädytä: theme.liquid lataa jQueryn
          tuotesivun <head>:ssä. Tämä on varalla jos se tag jostain syystä
          puuttuu (esim. muokattu template). */
    if (!stage1Done && elapsedVisible > 8000) {
      stage1Done = true;
      if (typeof window.jQuery === 'undefined') {
        var externals = function () {
          loadScript(JQ_VERSION_URL, function (ok2) {
            if (!ok2) loadScript(JQ_FALLBACK_URL, function () {});
          });
        };
        if (JQ_THEME_URL) loadScript(JQ_THEME_URL, function (ok) { if (!ok) externals(); });
        else externals();
      }
      return;
    }

    /* 2. Customily on ladattu mutta ei renderöinyt.

          Yleisin syy: sen oma jQuery-haku petti ennen kuin porras 1 ehti
          korjata tilanteen – Customily ei yritä uudelleen itsestään.
          Jos globaali puuttuu kokonaan, myös skripti on jäänyt saamatta
          ja se haetaan uudelleen. Toista kopiota EI injektoida silloin
          kun Customily on jo käynnissä: se tekisi tuplavalinnat. */
    if (!stage2Done && elapsedVisible > 14000) {
      stage2Done = true;
      if (typeof window.customilyShopify === 'undefined') {
        loadScript('https://cdn.customily.com/shopify/static/customily.shopify.script.js?shop=' +
                   (window.Shopify && window.Shopify.shop ? window.Shopify.shop : ''), function () {});
      }
      return;
    }

    /* 3. Viimeinen keino: kertaluontoinen uudelleenlataus.

          KAKSI EHTOA, molemmat pakollisia:

          a) 35 s. Mitattu 6.8.2026 Fast 3G:llä + 4× CPU-hidastuksella
             (5 kylmää latausta): personointi tuli 14,1–15,7 sekunnissa.
             Raja on siis yli kaksinkertainen mitattuun pahimpaan – hidas
             mutta onnistumassa oleva lataus ei saa keskeytyä.

          b) Customily ei ole käynnistynyt lainkaan. Jos globaali on
             olemassa, sovellus on elossa ja vain hidas; uudelleenlataus
             heittäisi kaiken jo ladatun hukkaan ja tekisi tilanteesta
             PAHEMMAN. Silloin odotetaan loputtomiin. */
    if (elapsedVisible > 35000) {
      clearInterval(timer);
      if (typeof window.customilyShopify !== 'undefined') return;
      var key = 'lastu:customily-reload:' + location.pathname;
      try {
        if (sessionStorage.getItem(key)) return;   // jo yritetty → ei silmukkaa
        sessionStorage.setItem(key, String(Date.now()));
      } catch (e) {
        return;   // ilman sessionStoragea ei voi taata kertaluontoisuutta → ei ladata
      }
      location.reload();
    }
  }, 1000);
})();

/* 9.10.2026: ATC-LUKON AVAUS poistettu (lastu-atc-lock-luokka poistettu teemasta, Customily pois käytöstä). */

/* =========================================================
   MINI-PREVIEWN VARAKUVA (7.8.2026)

   ONGELMA: hitaalla yhteydellä mini-preview oli ~10 s puhtaan valkoinen.
   Mitattu 600 kbit/s + 300 ms RTT, asiakkaan polku (napautus valintaan):
     2 s  snapshot 100 % valkoinen (canvas vasta 600x300)
     4–10 s  yhä 100 % valkoinen
     12 s  oikea sisältö

   Syy EI ole puuttuva kuva: Customilyn Custom JS kaappaa canvasin kerran
   sekunnissa ja asettaa sen mini-previewn <img>:iin. Canvas on olemassa,
   mutta Customily ei ole vielä ehtinyt piirtää siihen – sen tekstuurit
   latautuvat yhä. Kaappaus on siis validi JPEG tyhjästä canvasista.

   RATKAISU: kun kaappaus on käytännössä yksivärisen valkoinen, näytetään
   sen sijaan tuotteen oma galleriakuva. Se on jo ladattu (mitattu: näkyi
   27 s kohdalla kun optiot tulivat vasta 42 s), joten varakuva ei maksa
   yhtään lisätavua.

   MIKSI src:ään EI KOSKETA: Customilyn applySnapshot() vertaa
   `url !== snapshotImg.src` ja kirjoittaa oman arvonsa kerran sekunnissa.
   Jos kirjoittaisimme src:n, se ylikirjoittaisi meidät heti ja kuva
   välkkyisi sekunnin välein. Siksi blankki <img> vain häivytetään ja
   galleriakuva näytetään sen takana taustakuvana – kaksi mekanismia ei
   voi taistella samasta attribuutista.

   KUSTANNUS: 40x40 näyte 400 ms välein, ja VAIN kunnes ensimmäinen kelpo
   kaappaus on nähty. Sen jälkeen tarkistus lopetetaan kokonaan.
   getImageData ei kaadu tainttiin, koska <img> on data:-URL eli
   samaa alkuperää.
   ========================================================= */
(function () {
  'use strict';

  if (window.__lastuPreviewFallbackLoaded) return;
  window.__lastuPreviewFallbackLoaded = true;

  var IMG_SEL = '#lastu-customily-fixed-wrap .lastu-preview-mini-snapshot';
  var STAGE_SEL = '#lastu-customily-fixed-wrap .lastu-customily-preview-stage';
  var WHITE_LIMIT = 0.98;   // osuus lähes valkoisia pikseleitä → pidetään tyhjänä
  var GIVE_UP_MS = 90000;   // pitkäkään odotus ei saa jättää mittaria pyörimään

  var seenGood = false;
  var started = Date.now();
  var probe = null;

  function galleryImage() {
    var g = document.querySelector('.product__media-list img, media-gallery img, .product__media img');
    if (!g) return '';
    return g.currentSrc || g.src || '';
  }

  function looksBlank(img) {
    if (!img.naturalWidth) return true;          // ei vielä dekoodattu
    try {
      if (!probe) {
        probe = document.createElement('canvas');
        probe.width = 40; probe.height = 40;
      }
      var ctx = probe.getContext('2d', { willReadFrequently: true });
      ctx.clearRect(0, 0, 40, 40);
      ctx.drawImage(img, 0, 0, 40, 40);
      var d = ctx.getImageData(0, 0, 40, 40).data;
      var white = 0;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i] > 245 && d[i + 1] > 245 && d[i + 2] > 245) white++;
      }
      return (white / 1600) > WHITE_LIMIT;
    } catch (e) {
      /* Tainted canvas tms. – ei tietoa, joten ei puututa. Parempi näyttää
         Customilyn oma kuva kuin piilottaa se arvauksen perusteella. */
      return false;
    }
  }

  function clearFallback(stage) {
    if (!stage) return;
    stage.classList.remove('lastu-preview-fallback');
    stage.style.removeProperty('background-image');
    stage.style.removeProperty('background-size');
    stage.style.removeProperty('background-position');
    stage.style.removeProperty('background-repeat');
    stage.removeAttribute('data-lastu-fallback-src');
  }

  function tick() {
    var img = document.querySelector(IMG_SEL);
    if (!img) return;

    var stage = document.querySelector(STAGE_SEL);
    if (!stage) return;

    if (looksBlank(img)) {
      var url = galleryImage();
      if (url && stage.getAttribute('data-lastu-fallback-src') !== url) {
        /* Tausta asetetaan INLINE + important, ei CSS-luokan kautta.

           Customilyn Custom CSS asettaa tälle elementille
           `background: transparent !important` (rivi ~2499) ja
           `background: rgba(255,255,255,.55) !important` (~2444).
           background on LYHENNE, joten se nollaa myös background-imagen –
           ja sen selektori (html.x #id .luokka) on spesifisempi kuin
           mikään luokkapohjainen sääntö jonka voisin kirjoittaa.
           Inline + important voittaa aina, joten spesifisyyskilpailua
           ei tarvitse käydä lainkaan. */
        stage.style.setProperty('background-image', 'url("' + url + '")', 'important');
        stage.style.setProperty('background-size', 'contain', 'important');
        stage.style.setProperty('background-position', 'center', 'important');
        stage.style.setProperty('background-repeat', 'no-repeat', 'important');
        stage.setAttribute('data-lastu-fallback-src', url);
        stage.classList.add('lastu-preview-fallback');
      }
    } else {
      seenGood = true;
      clearFallback(stage);
      clearInterval(timer);
    }
  }

  var timer = setInterval(function () {
    if (seenGood || Date.now() - started > GIVE_UP_MS) {
      clearInterval(timer);
      clearFallback(document.querySelector(STAGE_SEL));   // fail-open
      return;
    }
    if (document.hidden) return;
    tick();
  }, 400);
})();

/* KUITTIKORIN KELLO – POISTETTU 13.8.2026 (ilta)

   Kuitin otsikossa oli päiväys ja kellonaika, jotka tämä lohko päivitti
   kävijän omaan aikaan (korin HTML voi tulla välimuistista). Kuitti
   pelkistettiin: päiväys, kellonaika, "Kuittiluonnos" ja "Palveli"
   poistettiin snippets/lastu-receipt.liquidista, joten
   [data-lastu-receipt-date] ja -clock eivät esiinny enää missään ja
   koodi jäi kuolleeksi. */

/* =========================================================
   KUITIN "ESIKATSELE" -LINKKI (13.8.2026)

   Kuvan klikkaus avaa lightboxin (patchThumbnails ylempänä). Tämä linkki
   ei avaa omaa toteutustaan vaan välittää klikkauksen samalle
   thumbnailille, joten lightboxin logiikkaa on vain yhdessä paikassa.

   Delegoitu kuuntelija: cart.js korvaa koko #MiniCart-lohkon jokaisella
   korin muutoksella, eikä uudelleensidontaa tarvita.
   ========================================================= */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-lastu-preview-link]');
    if (!link) return;
    e.preventDefault();

    var row = link.closest('li, tr');
    var thumb = row && row.querySelector('.lastu-cart-thumb');
    if (!thumb) return;

    /* Jos lightbox on ehtinyt sitoutua, click avaa sen. Jos ei (esim.
       JS latautui juuri), thumbnail on tavallinen linkki tuotesivulle –
       silloin ei tehdä mitään, ettei kori vaihdu sivuksi vahingossa. */
    if (thumb.dataset.lastuLbBound === '1') thumb.click();
  });
})();


/* =========================================================
   TUOTEKORTTIEN PALJASTUSANIMAATIO – TEEMAN OMA (24.8.2026)
   =========================================================
   Tässä oli hetken oma pehmennys, joka korvasi <motion-list>:n
   getAnimationParams-metodin (lyhyempi matka, lähes olematon
   porrastus). POISTETTU käyttäjän pyynnöstä: kokoelma- ja
   featured collection -ruudukot käyttävät nyt Conceptin omia
   arvoja sellaisenaan.

   Teeman arvot (theme.js, class MotionList):
     matka      50 px työpöytä / 30 px mobiili
     kesto      0,5 s / 0,3 s
     porrastus  0,1 s / 0,05 s per NÄKYVÄ kortti

   Jos pehmennys joskus halutaan takaisin, se tehdään korvaamalla
   ctor.prototype.getAnimationParams – EI muokkaamalla theme.js:ää,
   joka ylikirjoittuu teemapäivityksessä.
   ========================================================= */

/* =========================================================
   TUOTERUUDUKON VARMISTUS – FAIL-OPEN (24.8.2026)
   =========================================================
   <motion-list> PIILOTTAA kortit heti konstruktorissa (opacity 0)
   ja luottaa siihen että IntersectionObserver + Motion-kirjasto
   tuovat ne takaisin. Jos kumpi tahansa pettää – JS-virhe, IO ei
   laukea, bfcache-palautus, kirjaston lataus epäonnistuu – koko
   tuoteruudukko jää PYSYVÄSTI näkymättömäksi. Kauppa näyttäisi
   tyhjältä eikä mikään kertoisi virheestä.

   Sama periaate kuin lastu-atc-lockissa: mieluummin ilman
   animaatiota kuin ilman tuotteita.

   Ehdot on rajattu tiukasti, ettei tämä syö normaalia animaatiota:
     • vain listat jotka ovat näkyvissä tai heti sen alapuolella
       (kaukana alhaalla olevat SAAVAT olla piilossa – ne animoituvat
       vasta kun käyttäjä vierittää niiden kohdalle)
     • vain jos lista ei ole vielä 'initialized'
     • vain jos kortti on yhä täysin läpinäkymätön 8 s jälkeen
     • vain jos korteilla EI ole käynnissä olevaa animaatiota –
       teeman oma porrastus (0,1 s per kortti) voi kestää useita
       sekunteja isolla ruudukolla, eikä sitä saa katkaista
   ========================================================= */
(function () {
  'use strict';

  function rescue() {
    var lists = document.querySelectorAll('motion-list:not([initialized])');

    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var rect = list.getBoundingClientRect();

      /* Kaukana alhaalla oleva ruudukko saa jäädä odottamaan omaa
         vuoroaan – se ei ole rikki, se on vain vielä tulossa.

         vh-tarkistus on FAIL-OPEN: jos näkymän korkeutta ei saada
         (0 tai puuttuu), EI ohiteta. Varmistuksen koko idea on toimia
         silloin kun jokin on poikki – silloin se ei saa itse jäädä
         mittausvirheen taakse odottamaan. */
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (vh && rect.top > vh * 1.5) continue;

      var cards = list.querySelectorAll('.card');
      var stuck = 0;
      var animating = false;

      for (var j = 0; j < cards.length; j++) {
        if (window.getComputedStyle(cards[j]).opacity === '0') stuck++;
        /* Teeman porrastus on yhä kesken → ei kosketa. Ilman tätä
           varmistus katkaisisi ison ruudukon animaation hännän. */
        if (!animating && typeof cards[j].getAnimations === 'function') {
          var anims = cards[j].getAnimations();
          for (var a = 0; a < anims.length; a++) {
            if (anims[a].playState === 'running') { animating = true; break; }
          }
        }
      }
      if (!stuck || animating) continue;

      for (var k = 0; k < cards.length; k++) {
        cards[k].style.removeProperty('opacity');
        cards[k].style.removeProperty('visibility');
        cards[k].style.removeProperty('transform');
        cards[k].style.removeProperty('--motion-translateY');
      }
      list.setAttribute('initialized', '');
    }
  }

  function schedule() { setTimeout(rescue, 8000); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  /* Vierityksen jälkeen uusia listoja tulee näkyviin – tarkistetaan
     nekin kerran, harvakseltaan. */
  var scrollTimer = null;
  window.addEventListener('scroll', function () {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; rescue(); }, 8000);
  }, { passive: true });

  /* bfcache-paluu: sivu voi palata tilassa jossa animaatio on jo
     "käytetty" mutta tyylit yhä piilottavina. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
})();

/* ════════════════════════════════════════════════════════════
   MUOKKAUS: VANHAN RIVIN SIIVOUS (31.8.2026)

   ONGELMA. Customilyn "Edit Personalization" ei muokkaa koririviä
   paikallaan. Customilyn oma ohje sanoo sen suoraan: linkki palauttaa
   asiakkaan tuotesivulle personoimaan uudelleen ja lisäämään koriin
   toisen kerran, ja "the old product will need to be manually removed
   from the cart page".

   Lastulla se tarkoittaisi kahta käsin tehtyä puukuorta yhdellä
   tilauksella. Vielä pahempaa: personoidun päärivin lisäosat
   (MagSafe, KRIP, KARB, LEKA) ovat ERILLISIÄ koririvejä, jotka
   drawer piilottaa. Jos vain päärivi poistettaisiin, vanhat
   lisäosarivit jäisivät koriin näkymättömiksi mutta maksullisiksi.

   RATKAISU. Muokkauslinkki merkitsee rivin (data-lastu-edit-line), ja
   tämä moduuli poistaa vanhan päärivin JA sen lisäosarivit vasta kun
   korvaava lisäys on varmistunut korista.

   KOLME EHTOA, JOTTA KORIA KOSKETAAN. Yhdenkin puuttuminen = ei tehdä
   mitään:
     1. Lippu on alle 30 min vanha.
     2. Merkitty rivi on YHÄ korissa.
     3. Korissa on saman variantin rivi, jonka avainta EI ollut
        olemassa klikkihetkellä.

   Ehto 3 on se joka tekee tästä turvallisen. Pelkkä "sama variantti
   löytyy" ei riitä: asiakkaalla voi olla korissa jo kaksi eri designia
   samasta kuoresta, ja silloin pelkkä varianttivertailu poistaisi
   rivin heti ilman että mitään on muokattu. Siksi klikkihetkellä
   luetaan DOM:ista kaikki saman variantin rivikohtaiset avaimet
   (li[id^="CartDrawer-Item-"]) ja verrataan niihin.

   Poistot tehdään PERÄKKÄIN. /cart/change.js ei ole rinnakkaisturvallinen:
   kaksi yhtaikaista kutsua voi kirjoittaa toistensa yli.
   ════════════════════════════════════════════════════════════ */
(function initEditPersonalizationCleanup() {
  var FLAG = 'lastuEditingLine';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var ITEM_ID_PREFIX = 'CartDrawer-Item-';

  function readFlag() {
    try {
      var raw = sessionStorage.getItem(FLAG);
      if (!raw) return null;
      var f = JSON.parse(raw);
      if (!f || !f.key) return null;
      if (Date.now() - (f.ts || 0) > MAX_AGE_MS) { clearFlag(); return null; }
      return f;
    } catch (e) { return null; }
  }

  function clearFlag() {
    try { sessionStorage.removeItem(FLAG); } catch (e) {}
  }

  /* Kaikki korissa NYT olevat rivikohtaiset avaimet joilla on sama
     variantti. Luetaan DOM:ista, koska linkki navigoi heti eikä
     asynkroniselle /cart.js-kutsulle ole aikaa. */
  function siblingKeysForVariant(variant) {
    var keys = [];
    if (!variant) return keys;
    var rows = document.querySelectorAll('li[id^="' + ITEM_ID_PREFIX + '"]');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (String(row.getAttribute('data-variant-id') || '') !== String(variant)) continue;
      keys.push(row.id.slice(ITEM_ID_PREFIX.length));
    }
    return keys;
  }

  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('[data-lastu-edit-line]') : null;
    if (!link) return;
    var variant = link.getAttribute('data-lastu-edit-variant') || '';
    try {
      sessionStorage.setItem(FLAG, JSON.stringify({
        key: link.getAttribute('data-lastu-edit-line'),
        variant: String(variant),
        knownKeys: siblingKeysForVariant(variant),
        ts: Date.now()
      }));
    } catch (err) { /* private mode → muokkaus toimii, siivous ei */ }
  }, true);

  /* Peräkkäiset poistot. Palauttaa promisen joka ratkeaa kun kaikki on
     tehty; virhe yhdessä ei kaada muita. */
  function removeKeys(keys) {
    return keys.reduce(function (chain, key) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).catch(function () {});
      });
    }, Promise.resolve());
  }

  var busy = false;

  function sweep() {
    if (busy) return;
    var flag = readFlag();
    if (!flag) return;

    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var known = flag.knownKeys || [];
        var oldItem = null;
        var hasReplacement = false;

        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (it.key === flag.key) { oldItem = it; continue; }
          if (!flag.variant) continue;
          if (String(it.variant_id) !== String(flag.variant)) continue;
          /* Uusi avain jota ei ollut klikkihetkellä = korvaaja. */
          if (known.indexOf(it.key) === -1) hasReplacement = true;
        }

        /* Asiakas poisti vanhan rivin itse → ei enää tehtävää. */
        if (!oldItem) { clearFlag(); return; }

        /* Korvaajaa ei ole vielä lisätty → odotetaan seuraavaa
           korimuutosta. Lippu jää voimaan (max 30 min). */
        if (!hasReplacement) return;

        /* Päärivi + sen piilotetut lisäosarivit. */
        var mainUpsellId = oldItem.properties && oldItem.properties['_customily-upsell-main-id'];
        var toRemove = [oldItem.key];
        if (mainUpsellId) {
          for (var j = 0; j < items.length; j++) {
            var line = items[j];
            if (line.key === oldItem.key) continue;
            if (!line.properties) continue;
            if (line.properties['_customily-upsell-id'] === mainUpsellId) toRemove.push(line.key);
          }
        }

        clearFlag();
        return removeKeys(toRemove).then(function () {
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { open: true }
            }));
          } catch (e) {}
        });
      })
      .catch(function () { /* verkkovirhe → lippu jää, yritetään uudestaan */ })
      .then(function () { busy = false; });
  }

  /* Korvaava lisäys päättyy aina johonkin näistä. lastu:cart:rendered
     tulee Customily-sillasta (v6) vasta kun lisäys on vahvistettu
     palvelimelta, joten se on luotettavin hetki. */
  document.addEventListener('lastu:cart:rendered', sweep);
  document.addEventListener('cart:updated', sweep);

  /* Täyden sivulatauksen jälkeen: lisäys saattoi tapahtua ennen kuin
     tämä moduuli ehti kuunnella. Kevyt viive, ettei osu ATC-putken
     kriittiseen ikkunaan (Customily 7–9 s). */
  function armOnLoad() { setTimeout(sweep, 2500); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armOnLoad, { once: true });
  } else {
    armOnLoad();
  }
})();

/* ════════════════════════════════════════════════════════════
   EXPRESS-PAINIKKEIDEN ASETTELUA EI VOI OHJATA TEEMASTA
   (tutkittu ja todettu 31.8.2026 – älä yritä uudelleen)

   Tavoite oli pakottaa neljä express-painiketta kahteen sarakkeeseen,
   koska Shopify pinoaa ne pystyyn ja ne veivät mobiilissa ~230 px eli
   yli puolet drawerin alalaidasta.

   MIKSI SE EI ONNISTU. <shopify-accelerated-checkout-cart> on
   SULJETTU shadow DOM (element.shadowRoot === null). Sen light-DOM
   -lapset slotataan varjopuun omaan asettelusäiliöön, joten
   ulkopuolinen display:grid osuu SLOTTIIN eikä painikkeisiin – ne
   päätyvät yhteen sarakkeeseen pinoon riippumatta siitä mitä
   grid-template-columns sanoo. Tämä oli myös alkuperäisen livevian
   syy (neljä painiketta pinossa puolen leveyden sarakkeessa).

   Mitattu 31.8.2026 kolmella oikealla painikkeella:
     --shopify-accelerated-checkout-button-inline-size: calc(50% - 3px)
     → leveys pysyi 105 px
     sama arvoilla 80px ja 100%              → 105 px
     --shopify-accelerated-checkout-row-gap  → ei vaikutusta
   Ainoa muuttuja joka OIKEASTI vaikuttaa on
   --shopify-accelerated-checkout-button-block-size (korkeus), ja se
   on käytössä: 50 → 44 px mobiilissa (lastu-concept.css, osa H).

   Painikkeiden MÄÄRÄ vaihtelee selaimen mukaan: Safari ja Android
   näyttävät yleensä kolme (yksi rivi, ~61 px), iOS + Arc neljä
   (pino, ~205 px). Kolmen painikkeen tapaus on siis jo tiivis.

   Jos alalaita on joskus pakko saada pienemmäksi, ainoa toimiva keino
   on kytkeä express-painikkeet pois section-asetuksesta
   lastu_show_express_checkout – ei CSS-kikkailu.
   ════════════════════════════════════════════════════════════ */

/* ════════════════════════════════════════════════════════════
   9. shopify-account-paneelin suomentamattomat tekstit (2.9.2026)

   Shopifyn <shopify-account>-komponentti (kirjautuminen sivun päällä)
   tulee Shopifylta valmiiksi käännettynä, mutta osa riveistä on jäänyt
   englanniksi ("Use email instead"). Teksti asuu komponentin AVOIMESSA
   shadow rootissa, joten sen voi vaihtaa tekstisolmun tasolla. Tämä ei
   koske komponentin rakenteeseen: vain täsmälleen listatut lauseet
   vaihdetaan, ja jos Shopify korjaa käännöksen tai muuttaa tekstiä,
   tämä ei tee mitään. Vain suomenkielisellä sivulla (html lang="fi").
   ════════════════════════════════════════════════════════════ */
(function initAccountSheetFinnish() {
  if (!/^fi/i.test(document.documentElement.lang || '')) return;
  var MAP = {
    'Use email instead': 'Kirjaudu sähköpostilla',
    'Continue with email': 'Jatka sähköpostilla',
    'Sign in or create account': 'Kirjaudu sisään tai luo tili',
    'Profile': 'Profiili',
    'Orders': 'Tilaukset'
  };
  var watched = new WeakSet();

  function patchRoot(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue.trim();
      if (MAP[t]) node.nodeValue = node.nodeValue.replace(t, MAP[t]);
    }
    /* Paneelin painikkeet voivat olla omia web-komponentteja, joilla on
       oma (sisäkkäinen) shadow root – TreeWalker ei laskeudu niihin.
       Käydään kaikki elementit läpi ja otetaan sisäkkäiset juuret
       samaan vahtiin. */
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      if (els[i].shadowRoot) watch(els[i]);
    }
  }

  function watch(el) {
    var root = el.shadowRoot;
    if (!root || watched.has(root)) return;
    watched.add(root);
    patchRoot(root);
    new MutationObserver(function () { patchRoot(root); })
      .observe(root, { childList: true, subtree: true, characterData: true });
  }

  function scan() {
    document.querySelectorAll('shopify-account').forEach(watch);
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  /* attachShadow ei näy light DOMin mutaationa, ja komponentti alustuu
     vasta kun Shopifyn skripti on ladannut. Siksi skannataan myös kun
     elementti määritellään ja kun käyttäjä koskee sivuun (paneeli
     avataan aina klikillä tai kosketuksella). */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-account').then(scan).catch(function () {});
  }
  ['click', 'pointerdown', 'focusin'].forEach(function (evt) {
    document.addEventListener(evt, scan, true);
  });
  [1000, 3000, 6000, 10000].forEach(function (ms) { setTimeout(scan, ms); });
})();

/* ── Koridrawerin alalaita (18.9.2026) ──
   Kassapainike + maksutavat ovat position:absolute-paneeli vieritettävän
   listan PÄÄLLÄ. Paperin alapadding oli kiinteä 24 px, joten pitkässä
   korissa (4+ tuotetta) viimeiset rivit ja "Tyhjennä ostoskori" jäivät
   paneelin alle eikä niitä saanut vieritettyä esiin – etenkin mobiilissa,
   jossa maksutapa-ikonit rivittyvät ja paneeli on 170–330 px korkea.
   Ratkaisu: paneelin todellinen korkeus mitataan ja annetaan CSS-muuttujana
   --lastu-footer-h, jota paperin alapadding käyttää (lastu-concept.css). */
(function () {
  var ro = null, watched = null;
  function sync() {
    var cd = document.querySelector('cart-drawer'); if (!cd) return;
    var f = cd.querySelector('.drawer__footer');
    if (!f) { cd.style.removeProperty('--lastu-footer-h'); return; }
    var h = Math.ceil(f.getBoundingClientRect().height);
    if (h > 0) cd.style.setProperty('--lastu-footer-h', h + 'px');
    if (f !== watched && window.ResizeObserver) {
      if (ro) ro.disconnect();
      ro = new ResizeObserver(sync); ro.observe(f); watched = f;
    }
  }
  document.addEventListener('cart:refresh', function () { setTimeout(sync, 300); setTimeout(sync, 1200); });
  document.addEventListener('lastu-k:added', function () { setTimeout(sync, 600); });
  window.addEventListener('resize', sync);
  var mo = new MutationObserver(function () { setTimeout(sync, 50); });
  function arm() { var cd = document.querySelector('cart-drawer'); if (cd) { mo.observe(cd, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] }); sync(); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  [500, 2000].forEach(function (ms) { setTimeout(sync, ms); });
})();

/* ── Oman konfiguraattorin lisäosarivien siivous (18.9.2026) ──
   Konfiguraattori lisää päätuotteen + piilotetut lisäosarivit (malli,
   materiaali, MagSafe, KRIP, LEKA…) yhdellä pyynnöllä. Lisäosarivit
   kantavat _customily-upsell-id = "_lastu-id-…", päärivi
   _customily-upsell-main-id = sama arvo. Kun asiakas poistaa päärivin
   korin Poista-linkistä, teema poistaa vain sen rivin → lisäosat jäivät
   koriin näkymättöminä mutta maksullisina.
   Tämä moduuli tarkistaa jokaisen korimuutoksen jälkeen orvot
   "_lastu-id-"-lisäosat ja poistaa ne yhdellä /cart/update.js-kutsulla.
   Customilyn omia (muun muotoisia) upsell-id:itä EI kosketa: niiden
   suoja on lastu-customily-bridge.liquidissä ja Customilyn siivouksessa. */
(function initLastuOrphanSweep() {
  if (window.__lastuOrphanSweepLoaded) return;
  window.__lastuOrphanSweepLoaded = true;
  var PREFIX = '_lastu-id-', busy = false, timer = null;

  function sweep() {
    if (busy) return; busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var mains = {}, orphans = {};
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {};
          if (p['_customily-upsell-main-id'] && String(p['_customily-upsell-main-id']).indexOf(PREFIX) === 0) mains[p['_customily-upsell-main-id']] = true;
        });
        (cart.items || []).forEach(function (it) {
          var p = it.properties || {}, id = p['_customily-upsell-id'];
          if (id && String(id).indexOf(PREFIX) === 0 && !mains[id]) orphans[it.key] = 0;
        });
        var n = Object.keys(orphans).length;
        if (!n) return null;
        return fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Lastu-Sweep': '1' },
          body: JSON.stringify({ updates: orphans })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false, source: 'lastu-orphan-sweep' } }));
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  function schedule(ms) { clearTimeout(timer); timer = setTimeout(sweep, ms || 250); }

  /* Kuunnellaan korimuutokset: teeman poisto/määrä (/cart/change.js), muut päivitykset. */
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && init.headers['X-Lastu-Sweep'];
    var p = origFetch.apply(this, arguments);
    if (!mine && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(function () { schedule(300); }, function () {});
    return p;
  };
  document.addEventListener('cart:refresh', function (e) { if (!(e.detail && e.detail.source === 'lastu-orphan-sweep')) schedule(600); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(800); }); else schedule(800);
})();


/* ── Korin lisämyynti: MagSafe + KRIP 2.0 yhdellä klikkauksella (20.9.2026) ──
   Kortti: snippets/lastu-cart-upsell.liquid (vain riveille joilla _lastu_upsell_ok).
   Lisää: 2 piilotettua lisäosariviä samalla upsell-id:llä kuin päärivi (MagSafe 0 € -variantti
   "koritarjous" + KRIP 10 €) ja päivittää päärivin propertyt kuin konfiguraattori olisi ne
   valinnut → tuotanto/raportit/skanneri näkevät tutun rakenteen. Jälki: _lastu_upsell.
   "Ei kiitos" piilottaa kortin istunnon ajaksi (sessionStorage). Info = kevyt arkki korin päällä. */
/* ESIKATSELULINKKI SELAIMEEN (23.9.2026): Shopifyn CDN palauttaa line item -tiedostot
   `content-disposition: attachment` → tilauksen _customily-preview latautuu koneelle.
   Koriin lisäyksen jälkeen päärivin propertyihin lisätään linkki lastu.co/pages/esikatselu?k=<tiedosto>,
   joka näyttää saman kuvan selaimessa (<img> ei välitä attachment-otsakkeesta). Tuotantotiedostot
   latautuvat edelleen normaalisti. Palauttaa rivin uuden avaimen (propertyjen muutos vaihtaa avaimen)
   tai null. Ei koskaan hylkää lupausta – virhe tai 3 s aikakatkaisu = ei linkkiä. */
(function initLastuPreviewLink() {
  if (window.__lastuPreviewLink) return;
  var PK = '_Esikatselu (avaa selaimessa)';
  function linkFor(url) { var m = /\/uploads\/([0-9a-f]{32}\.(?:jpe?g|png|webp))(?:\?|$)/i.exec(url || ''); return m ? 'https://lastu.co/pages/esikatselu?k=' + m[1] : null; }
  window.__lastuPreviewLink = function (line) {
    var props = (line && line.properties) || {}, link = linkFor(props['_customily-preview']);
    if (!link || props[PK] === link) return Promise.resolve(null);
    var np = {}; Object.keys(props).forEach(function (k) { if (props[k] != null && props[k] !== '') np[k] = props[k]; }); np[PK] = link;
    var job = fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: line.quantity || 1, properties: np }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { var it = cart && (cart.items || []).filter(function (x) { return (x.properties || {})[PK] === link; })[0]; return it ? it.key : null; })
      .catch(function () { return null; });
    return Promise.race([job, new Promise(function (res) { setTimeout(function () { res(null); }, 3000); })]);
  };
})();

(function initLastuCartUpsell() {
  if (window.__lastuCartUpsellLoaded) return;
  window.__lastuCartUpsellLoaded = true;
  var DIS = 'lastuUpsellDismissed';
  function dismissed() { try { return JSON.parse(sessionStorage.getItem(DIS) || '[]'); } catch (e) { return []; } }
  function applyDismissed() {
    var d = dismissed();
    document.querySelectorAll('.lastu-upsell[data-key]').forEach(function (el) { if (d.indexOf(el.getAttribute('data-key')) >= 0) el.classList.add('is-hidden'); });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; }); });
  }
  /* ESIKATSELUN PÄIVITYS: vanha esikatselu (1200×960 JPEG Shopifyn CDN:llä, CORS *) + MagSafe-
     rengas + KRIP-taso piirretään samaan paikkaan kuin konfiguraattorissa → uusi JPEG lähetetään
     päärivin _customily-preview-tiedostona. Jos mikä tahansa vaihe epäonnistuu tai kestää yli 4 s,
     lisäys tehdään ilman kuvan päivitystä – asiakas ei näe virhettä. */
  function loadImg(url) {
    return new Promise(function (res, rej) { if (!url) return rej(new Error('no url')); var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = function () { rej(new Error('img')); }; im.src = url; });
  }
  function composePreview(prevUrl, layers) {
    if (!prevUrl || !/^https?:\/\//.test(prevUrl)) return Promise.resolve(null);
    var work = Promise.all([loadImg(prevUrl)].concat((layers || []).map(loadImg))).then(function (im) {
      var W = 1200, H = 960, c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d');
      im.forEach(function (m) { x.drawImage(m, 0, 0, W, H); });
      return new Promise(function (res) { c.toBlob(function (b) { res(b || null); }, 'image/jpeg', 0.86); });
    }).catch(function () { return null; });
    var timeout = new Promise(function (res) { setTimeout(function () { res(null); }, 4000); });
    return Promise.race([work, timeout]);
  }
  function addForm(items, previewBlob, mainIndex) {
    var fd = new FormData();
    items.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id); fd.append('items[' + i + '][quantity]', it.quantity);
      Object.keys(it.properties || {}).forEach(function (k) {
        if (i === mainIndex && k === '_customily-preview' && previewBlob) return;
        fd.append('items[' + i + '][properties][' + k + ']', it.properties[k]);
      });
    });
    if (previewBlob) fd.append('items[' + mainIndex + '][properties][_customily-preview]', new File([previewBlob], 'lastu-esikatselu.jpg', { type: 'image/jpeg' }));
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || r.status); return j; }); });
  }
  function add(card) {
    var key = card.getAttribute('data-key'), uid = card.getAttribute('data-upsell-id'), qty = parseInt(card.getAttribute('data-qty')) || 1;
    /* 26.9.2026: lisättävät osat kortilta (data-add) tai valitusta vaihtoehdosta (choose-tarjous). */
    var pick = card.querySelector('input[data-add]:checked'), comps = [];
    try { comps = JSON.parse((pick || card).getAttribute('data-add') || '[]'); } catch (e) { comps = []; }
    if (!comps.length) return Promise.resolve();
    var offer = pick ? pick.value : card.getAttribute('data-lastu-upsell');
    var btns = card.querySelectorAll('[data-upsell-add]'); var fi = (document.documentElement.lang || 'fi').indexOf('en') !== 0;
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('data-label', b.textContent); b.textContent = fi ? 'Lisätään…' : 'Adding…'; });
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var line = (cart.items || []).filter(function (it) { return it.key === key; })[0]
        || (uid ? (cart.items || []).filter(function (it) { var q = it.properties || {}; return q['_customily-upsell-main-id'] === uid && q._lastu_konfiguraattori; })[0] : null);   /* 3.10.: avain vaihtunut */
      if (!line) throw new Error('line missing'); key = line.key;
      var props = {}; Object.keys(line.properties || {}).forEach(function (k) { if (k !== '_lastu_upsell_ok') props[k] = line.properties[k]; });
      comps.forEach(function (c) { props[c.k] = 'on'; }); props['_lastu_upsell'] = offer;
      var mk = function (name) { return { '_customily-option-name': name, '_customily-upsell-id': uid, '_customily-upsell-multiplier': '1', '_lastu_upsell': offer }; };
      /* JÄRJESTYS TILAUKSESSA: koko ryhmä (päärivi + sen lisäosat) poistetaan ja lisätään
         uudelleen yhdellä pyynnöllä käänteisessä järjestyksessä → kori/tilaus: päätuote,
         materiaali, malli, personointi…, MagSafe, KRIP, LEKA. Pelkkä muutos jättäisi uudet
         rivit päärivin yläpuolelle. Jos uudelleenlisäys epäonnistuu, alkuperäiset palautetaan. */
      var group = (cart.items || []).filter(function (it) { return it.key !== key && (it.properties || {})['_customily-upsell-id'] === uid; });
      var strip = function (it) { return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }; };
      var main = { id: line.variant_id, quantity: qty, properties: props };
      var leka = group.filter(function (it) { return /LEKA/i.test((it.properties || {})['_customily-option-name'] || ''); });
      var rest = group.filter(function (it) { return leka.indexOf(it) < 0; });
      var ordered = [main].concat(rest.map(strip)).concat(comps.map(function (c) { return { id: +c.v, quantity: qty, properties: mk(c.k) }; })).concat(leka.map(strip));
      var removes = {}; removes[key] = 0; group.forEach(function (it) { removes[it.key] = 0; });
      var originals = [line].concat(group).map(strip).reverse();
      var sendList = ordered.slice().reverse(), mainIndex = sendList.length - 1;
      /* Esikatselu piirretään ENNEN korin muutoksia, jotta kori ei ole hetkeäkään tyhjänä turhaan. */
      return composePreview((line.properties || {})['_customily-preview'], comps.map(function (c) { return c.img; })).then(function (blob) {
        return post('/cart/update.js', { updates: removes })
          .then(function () { return addForm(sendList, blob, mainIndex).then(function (j) {
            /* Uusi esikatselu → päivitetään myös selaimessa aukeava esikatselulinkki. */
            var ml = (j.items || []).filter(function (it) { var p = it.properties || {}; return p._lastu_konfiguraattori && p['_customily-upsell-main-id']; })[0];
            return ml && window.__lastuPreviewLink ? window.__lastuPreviewLink(ml) : null;
          }); })
          .catch(function (e) { return post('/cart/add.js', { items: originals }).then(function () { throw e; }); });
      });
    }).then(function () {
      var m = card.querySelector('[data-upsell-modal]'); if (m) m.hidden = true;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true, source: 'lastu-upsell' } }));
    }).catch(function (e) {
      btns.forEach(function (b) { b.disabled = false; b.textContent = b.getAttribute('data-label') || b.textContent; });
      var t = card.querySelector('.lastu-upsell__txt span'); if (t) t.textContent = (document.documentElement.lang || '').indexOf('en') === 0 ? 'Could not add – please try again.' : 'Lisäys ei onnistunut – yritä uudelleen.';
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var card = t.closest('.lastu-upsell'); if (!card) return;
    if (t.closest('[data-upsell-add]')) { e.preventDefault(); add(card); return; }
    if (t.closest('[data-upsell-info]')) { e.preventDefault(); var m = card.querySelector('[data-upsell-modal]'); if (m) { m.hidden = false; var c = m.querySelector('[data-upsell-close]'); if (c) c.focus(); } return; }
    if (t.closest('[data-upsell-close]') || (t.classList && t.classList.contains('lastu-upsell__modal'))) { e.preventDefault(); var m2 = card.querySelector('[data-upsell-modal]'); if (m2) { m2.hidden = true; var ib = card.querySelector('[data-upsell-info]'); if (ib) ib.focus(); } return; }
    if (t.closest('[data-upsell-dismiss]')) {
      e.preventDefault(); var d = dismissed(); d.push(card.getAttribute('data-key'));
      try { sessionStorage.setItem(DIS, JSON.stringify(d)); } catch (err) {}
      card.classList.add('is-hidden');
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('[data-upsell-modal]:not([hidden])').forEach(function (m) { m.hidden = true; }); });
  /* 29.9.2026: pakettiedun valintanapit ovat korilomakkeen sisällä → teeman cart-items tulkitsi niiden
     change-tapahtuman määrämuutokseksi ("Voit lisätä tämän tuotteen vain erissä, jotka ovat…").
     Pysäytetään tapahtumat jo kaappausvaiheessa dokumentissa, ennen teeman kuuntelijoita. */
  ['change', 'input'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var t = e.target; if (!t || !t.closest || !t.closest('.lastu-upsell')) return;
      e.stopPropagation(); if (t.setCustomValidity) t.setCustomValidity('');
    }, true);
  });
  var mo = new MutationObserver(function () { applyDismissed(); });
  function arm() { var cd = document.querySelector('cart-drawer'); if (cd) mo.observe(cd, { childList: true, subtree: true }); applyDismissed(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
})();

/* ───────── Lisäosan poisto korin riviltä (3.10.2026) ─────────
   × MagSafe/KRIP/KARB/LEKA-rivillä (cart-drawer.liquid, data-lastu-addon-remove):
   1) päärivin property pois (+ LEKA-määrä), lisäosan koririvi pois
   2) MagSafe pois → myös KRIP ja KARB pois (ne tarvitsevat renkaan); 2-vaiheinen vahvistus jos niitä on
   3) pakettihinnat oikaistaan: MagSafe 0 € (MAGSAFE-KORI) → 5 € jos lisäosaa ei jää; KARB 10 € (KORI) → 15 € jos KRIP poistuu
   4) esikatselu piirretään uudelleen: _lastu-pohja (konfiguraattorin kuva ilman lisäosia) + jäljelle jäävät
      kerrokset mallin mittakaavassa (_lastu_acc "s,dy", sama accDraw kuin konfiguraattorissa). Ilman pohjaa
      (vanhat korit) esikatselu jää ennalleen.
   Ryhmä poistetaan ja lisätään uudelleen yhdellä pyynnöllä kuten pakettiedussa (järjestys säilyy). */
(function initLastuAddonRemove() {
  if (window.__lastuAddonRemoveLoaded) return;
  window.__lastuAddonRemoveLoaded = true;
  var K_MS = 'Lisää MagSafe kuoreesi (+5€)', K_KRIP = 'KRIP 2.0 - MagSafe sormipidike (+10€)',
      K_KARB = 'KARB - MagSafe lompakko - Musta (+15€)', K_KARB_G = 'KARB - MagSafe lompakko - Vihreä (+15€)',
      K_LEKA = 'Lisää LEKA -näytönsuoja (+5€)', K_LEKA_N = 'Montako laitetaan?', isLekaK = function (k) { return /^Lisää LEKA -näytönsuoja/.test(k || ''); };   /* 9.10.2026 hinta 6 → 5 €: vanhat (+6€) koririvit tunnistetaan yhä */
  var V_MS_FREE = 55083541987671, V_MS = 42009196495064, V_KARB10 = 55171445784919, V_KARB = 37783880269977;
  var IMG = {}; IMG[K_MS] = 'https://cdn.shopify.com/s/files/1/2588/4384/files/lastu-k-lisaosa-magsafe.webp?v=1789627974';
  IMG[K_KRIP] = 'https://cdn.shopify.com/s/files/1/2588/4384/files/lastu-k-lisaosa-krip.webp?v=1789627974';
  IMG[K_KARB] = 'https://cdn.shopify.com/s/files/1/2588/4384/files/lastu-k-lisaosa-karb-musta.webp?v=1789627974';
  IMG[K_KARB_G] = 'https://cdn.shopify.com/s/files/1/2588/4384/files/lastu-k-lisaosa-karb-vihrea.webp?v=1789627974';
  var ACC_C = { x: 599.1, y: 493 }, ACC_K = { x: 198.5, y: 649.5 }, W = 1200, H = 960;
  var fi = function () { return (document.documentElement.lang || 'fi').indexOf('en') !== 0; };
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; }); });
  }
  function loadImg(u) { return new Promise(function (res, rej) { var im = new Image(); im.crossOrigin = 'anonymous'; im.onload = function () { res(im); }; im.onerror = rej; im.src = u; }); }
  function compose(baseUrl, keys, acc) {
    if (!baseUrl || !/^(https?:\/\/|data:image\/)/.test(baseUrl)) return Promise.resolve(null);
    var a = String(acc || '1,0').split(','), s = parseFloat(a[0]) || 1, dy = parseFloat(a[1]) || 0;
    var order = [K_MS, K_KRIP, K_KARB, K_KARB_G].filter(function (k) { return keys.indexOf(k) >= 0; });
    var work = Promise.all([loadImg(baseUrl)].concat(order.map(function (k) { return loadImg(IMG[k]); }))).then(function (im) {
      var c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d');
      x.drawImage(im[0], 0, 0, W, H);
      im.slice(1).forEach(function (img, i) {
        var karb = order[i] === K_KARB || order[i] === K_KARB_G;
        if (s === 1 && !dy) { x.drawImage(img, 0, 0, W, H); return; }
        var cc = karb ? ACC_K : ACC_C, ty = karb ? 0 : dy;
        x.save(); x.translate(cc.x * (1 - s), cc.y * (1 - s) + ty); x.scale(s, s); x.drawImage(img, 0, 0, W, H); x.restore();
      });
      return new Promise(function (res) { c.toBlob(function (b) { res(b || null); }, 'image/jpeg', 0.86); });
    }).catch(function () { return null; });
    return Promise.race([work, new Promise(function (r) { setTimeout(function () { r(null); }, 4000); })]);
  }
  function addForm(items, blob, mainIndex) {
    var fd = new FormData();
    items.forEach(function (it, i) {
      fd.append('items[' + i + '][id]', it.id); fd.append('items[' + i + '][quantity]', it.quantity);
      Object.keys(it.properties || {}).forEach(function (k) { if (i === mainIndex && k === '_customily-preview' && blob) return; fd.append('items[' + i + '][properties][' + k + ']', it.properties[k]); });
    });
    if (blob) fd.append('items[' + mainIndex + '][properties][_customily-preview]', new File([blob], 'lastu-esikatselu.jpg', { type: 'image/jpeg' }));
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || r.status); return j; }); });
  }
  function remove(btn) {
    var key = btn.getAttribute('data-key'), pk = btn.getAttribute('data-lastu-addon-remove');
    btn.disabled = true; btn.classList.add('is-busy');
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var uid0 = btn.getAttribute('data-uid');
      var line = (cart.items || []).filter(function (it) { return it.key === key; })[0]
        || (uid0 ? (cart.items || []).filter(function (it) { var q = it.properties || {}; return q['_customily-upsell-main-id'] === uid0 && q._lastu_konfiguraattori; })[0] : null);   /* avain vaihtunut (esikatselulinkki) */
      if (!line) throw new Error('line'); key = line.key;
      var P = line.properties || {}, uid = P['_customily-upsell-main-id'];
      var group = (cart.items || []).filter(function (it) { return it.key !== key && uid && (it.properties || {})['_customily-upsell-id'] === uid; });
      var drop = [pk]; if (pk === K_MS) drop = drop.concat([K_KRIP, K_KARB, K_KARB_G]);
      var props = {}; Object.keys(P).forEach(function (k) { if (drop.indexOf(k) < 0 && !(isLekaK(pk) && k === K_LEKA_N)) props[k] = P[k]; });
      var optName = function (it) { return (it.properties || {})['_customily-option-name'] || ''; };
      var kept = group.filter(function (it) { return drop.indexOf(optName(it)) < 0; });
      var has = function (k) { return kept.some(function (it) { return optName(it) === k; }); };
      var strip = function (it) { return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }; };
      var keptOut = kept.map(function (it) {
        var o = strip(it), n = optName(it);
        if (n === K_MS && it.variant_id === V_MS_FREE && !has(K_KRIP) && !has(K_KARB) && !has(K_KARB_G)) o.id = V_MS;   /* paketti purkautui → MagSafe normaalihintaan */
        if (n === K_KARB && it.variant_id === V_KARB10 && !has(K_KRIP)) o.id = V_KARB;                                /* KARB-pakettihinta vaati KRIPin */
        return o;
      });
      var leka = keptOut.filter(function (o) { return /LEKA/i.test((o.properties || {})['_customily-option-name'] || ''); });
      var rest = keptOut.filter(function (o) { return leka.indexOf(o) < 0; });
      var ordered = [{ id: line.variant_id, quantity: line.quantity, properties: props }].concat(rest).concat(leka);
      var sendList = ordered.slice().reverse(), mainIndex = sendList.length - 1;
      var removes = {}; removes[key] = 0; group.forEach(function (it) { removes[it.key] = 0; });
      var originals = [line].concat(group).map(strip).reverse();
      var layerKeys = [K_MS, K_KRIP, K_KARB, K_KARB_G].filter(function (k) { return props[k]; });
      var needPreview = drop.some(function (k) { return !isLekaK(k) && P[k]; });
      var baseUrl = P['_lastu-pohja']; if (!baseUrl) { try { var lb = JSON.parse(localStorage.getItem('lastuBase') || '{}')[uid]; if (lb) baseUrl = lb.d; } catch (e0) {} }   /* 3.10.: pohja selaimesta (ei enää ladata koriin) */
      return (needPreview ? compose(baseUrl, layerKeys, P['_lastu_acc']) : Promise.resolve(null)).then(function (blob) {
        return post('/cart/update.js', { updates: removes })
          .then(function () { return addForm(sendList, blob, mainIndex).then(function (j) {
            var ml = (j.items || []).filter(function (it) { var p = it.properties || {}; return p._lastu_konfiguraattori && p['_customily-upsell-main-id']; })[0];
            return ml && window.__lastuPreviewLink ? window.__lastuPreviewLink(ml) : null;
          }); })
          .catch(function (e) { return post('/cart/add.js', { items: originals }).then(function () { throw e; }); });
      });
    }).then(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true, source: 'lastu-addon-remove' } }));
    }).catch(function () {
      btn.disabled = false; btn.classList.remove('is-busy');
      btn.setAttribute('title', fi() ? 'Poisto ei onnistunut – yritä uudelleen.' : 'Could not remove – please try again.');
    });
  }
  /* Rivin merkintä JS:llä: korin sections-haku voi palauttaa välimuistista vanhaa HTML:ää ilman .has-x-luokkaa
     → × putosi omalle rivilleen. Merkitään jokainen ×-napin rivi aina, kun drawerin sisältö vaihtuu. */
  function markRows() { document.querySelectorAll('.lastu-opt__x').forEach(function (b) { var r = b.closest('.lastu-props__row'); if (r && !r.classList.contains('has-x')) r.classList.add('has-x'); }); }
  var markT = 0, markMo = new MutationObserver(function () { clearTimeout(markT); markT = setTimeout(markRows, 30); });
  function markArm() { markRows(); markMo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markArm); else markArm();
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-lastu-addon-remove]') : null; if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.disabled) return;
    /* MagSafe + lisäosia → ensimmäinen napautus pyytää vahvistuksen (poistaa myös KRIP/KARB). */
    if (btn.getAttribute('data-lastu-addon-remove') === K_MS && !btn.classList.contains('is-confirm')) {
      var row = btn.closest('dl'), deps = row && row.querySelector('[data-lastu-addon-remove^="KRIP"], [data-lastu-addon-remove^="KARB"]');
      if (deps) {
        btn.classList.add('is-confirm'); btn.setAttribute('data-x', btn.textContent); btn.textContent = fi() ? 'Poista kaikki?' : 'Remove all?'; btn.setAttribute('aria-label', fi() ? 'Poista MagSafe, sormipidike ja lompakko' : 'Remove MagSafe, grip and wallet');
        setTimeout(function () { if (btn.isConnected && btn.classList.contains('is-confirm')) { btn.classList.remove('is-confirm'); btn.textContent = btn.getAttribute('data-x') || '×'; } }, 4000);
        return;
      }
    }
    remove(btn);
  }, true);
})();

/* =========================================================
   TUOTERUUDUKOT ILMAN PALJASTUSANIMAATIOTA (10.10.2026)
   =========================================================
   Kaikissa <motion-list>-elementeissä on nyt `motion-reduced` (sections/*.liquid),
   jolloin konstruktori ei piilota kortteja. Suodatus/lajittelu kutsuu kuitenkin
   reload()-metodia, joka animoi kortit opacity 0 → 1 (0,001 s) – jos Motion ei ehdi
   (taustavälilehti, jumi), kortit jäisivät näkymättömiksi. Reduced-listoille reload
   on siksi pelkkä siivous: tyylit pois, kortit näkyviin heti. */
(function () {
  'use strict';
  function patch() {
    var C = window.customElements && customElements.get('motion-list');
    if (!C || C.prototype.__lastuNoReveal) return !!C;
    var orig = C.prototype.reload;
    C.prototype.reload = function () {
      if (!this.hasAttribute('motion-reduced')) return orig.apply(this, arguments);
      this.items.forEach(function (el) { ['opacity', 'visibility', 'transform'].forEach(function (p) { el.style.removeProperty(p); }); });
      return Promise.resolve();
    };
    C.prototype.__lastuNoReveal = true;
    return true;
  }
  if (!patch() && window.customElements) customElements.whenDefined('motion-list').then(patch);
})();
